module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6kwFz"))).then(() => module.bundle.root('dsisd'));